import { ReportUserRightsProperties } from "./AgencyRightsProperties";

export class NavMenuItems {
      profileUpdate: boolean = false;
      supplierManagement: boolean = false;

      beneficiaryAccount: boolean = false;
      allocatedAccount: boolean = false;
      paymentProcess: boolean = false;
      paymentList: boolean = false;
      managerPaymentList: boolean = false;
      addPayment: boolean = false;
      deletePayment: boolean = false;
      approvePayment: boolean = false;
      creditLimit: boolean = false;
      notifications: boolean = false;
      offlineRequest: boolean = false;
      revenueManagement: boolean = false;
      offlineSettings: boolean = false;
      cms: boolean = false;
      accountManagement: boolean = false;
      account: boolean = false;
      users: boolean = false;
      logs: boolean = false;
      currency: boolean = false;
      bookings: boolean = false;
      searchBookings: boolean = false;
      viewBookings: boolean = false;
      updateBookings: boolean = false;
      reports: boolean = false;
      dashBoard: boolean = false;

      // agent
      quotations: boolean = false;
      book: boolean = false;
      issueTicket: boolean = false;
      issuePNR: boolean = false;
      cancelTicket: boolean = false;
      cancelPNR: boolean = false;

      voidTicket: boolean = false;
      fareRulesResult: boolean = false;

      //offlineBooking : boolean = false;
      reprice: boolean = false;



      refund: boolean = false;
      offlineRefund: boolean = false;

      exchange: boolean = false;

      calenderSearch: boolean = false;

      recentSearch: boolean = false;

      adminPanelLogin: boolean = false;

      newBookings: boolean = false;
      myBookings: boolean = false;
      managerOfflineRequestList: boolean = false;
      offlineRequestList: boolean = false;
      airport: boolean = false;
      airline: boolean = false;
      reportsManage: boolean = false;
      importPnr: boolean = false;
      reportUserRights: ReportUserRightsProperties[] = [];
      //public bool searchBookings : boolean = false;


      groupTicketRight: boolean = false;
      groupTicketCreateRight: boolean = false;
      groupTicketListRight: boolean = false;
      modifyBooking: boolean = false;
  insuranceIssuanceRight: boolean = false;
    
  insuranceBookedViewRight: boolean = false;
  insuranceCancelRight: boolean = false;
  insuranceRight: boolean = false;
 
  offlineBooking: boolean;
  offlineTicket: boolean;
  offlineVoid: boolean;
  offlineResissue: boolean;
  // searchBookings?: boolean;
  offlineManage: boolean;
  offlineManageRefund: boolean;
  offlineManageBooking: boolean;
  offlineManageTicket: boolean;
  offlineManageVoid: boolean;
  offlineManageResissue: boolean;


}
